module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-6-559f5579d16e56486ba20740936ec961.jpg";